import { useDispatch } from 'react-redux'
import { useMemo } from 'react'
import {
  FinnishTailoringButton,
  StartTailoringButton,
  TailoringFromPublicJobBoardStep2Buttons,
} from 'builder/components/DocumentEditor/TailoringFromPublicJobBoard'
import Icon24 from 'builder/components/Icon'
import { navigate } from 'builder/modules/navigate'
import { useI18n } from 'builder/hooks/useI18n'
import {
  AutoTailoringFromPublicJobBoardMode,
  actions,
  AutoTailoringFromPublicJobBoardStep,
  selectors,
} from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'

import { FetchStatuses } from 'builder/modules/constants'
import { BackIcon, Center, Container, Step, Title, WrapperStartTailoringButton } from './styles'
export const TailoringFromPublicJobBoardHeader = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { step, mode } = useTypedSelector(selectors.autoTailoringFromPublicJobBoard)

  const renderButtons = () => {
    if (step === AutoTailoringFromPublicJobBoardStep.step1) {
      return <StartTailoringButton width="183px" />
    }

    if (step === AutoTailoringFromPublicJobBoardStep.step2) {
      return <TailoringFromPublicJobBoardStep2Buttons />
    }

    if (step === AutoTailoringFromPublicJobBoardStep.finished) {
      return <FinnishTailoringButton />
    }

    return null
  }

  const onBack = () => {
    if (step === AutoTailoringFromPublicJobBoardStep.step1) {
      navigate('/')
      return
    }

    if (step === AutoTailoringFromPublicJobBoardStep.step2) {
      return
    }

    if (step === AutoTailoringFromPublicJobBoardStep.finished) {
      dispatch(
        actions.setAutoTailoringForPublicJobBoard({
          processingAutoTailoring: FetchStatuses.loaded,
        }),
      )
      return
    }

    return null
  }

  const titleTranslation = useMemo(() => {
    if (step === AutoTailoringFromPublicJobBoardStep.step2) {
      return `title_tailor_resume`
    }

    if (mode === AutoTailoringFromPublicJobBoardMode.reviewResume) {
      return `title_review_resume`
    }
    return `title_create_resume`
  }, [mode, step])

  const stepNumber = useMemo(() => {
    if (step === AutoTailoringFromPublicJobBoardStep.step1) {
      return 1
    }

    return 2
  }, [step])

  if (step === AutoTailoringFromPublicJobBoardStep.modal) {
    return null
  }

  return (
    <Container>
      <BackIcon onClick={onBack}>
        {step !== AutoTailoringFromPublicJobBoardStep.step2 && <Icon24.ArrowRight />}
      </BackIcon>
      <Center>
        <Title>
          {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.${titleTranslation}`)}
        </Title>

        <Step
          dangerouslySetInnerHTML={{
            __html: i18n.t(`builder.prefill_resume.auto_tailoring_view.header.step`, {
              startStep: stepNumber,
              endStep: 2,
            }),
          }}
        />
      </Center>
      <WrapperStartTailoringButton>{renderButtons()}</WrapperStartTailoringButton>
    </Container>
  )
}
